import styled from 'styled-components';
import { IonPage } from '@ionic/react';

export const ProfileScreenWrapper = styled(IonPage)`
  .content {
  }
`;
